
<template>
    
        <mars-view class="swiper-box"><mars-swiper class="swiper-list-box" :autoplay="swiperList.length > 1" :interval="3000" :vertical="true" :circular="true"><mars-swiper-item class="swiper-item-box" v-for="item,index in swiperList" :key="index"><mars-view class="box"><mars-view class="swiper-item"><mars-view class="avatar-box"><mars-view class="avatar" :style="{
                                backgroundImage: 'url(' + item.avator + ')',
                            }"></mars-view></mars-view><mars-view class="desc lineclamp1">{{ item.writing }}</mars-view></mars-view></mars-view></mars-swiper-item></mars-swiper></mars-view>
    
</template>

<script>
export default {
  props: {
    swiperList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.swiper-box .swiper-list-box {
  height: 6.35vw;
}
.swiper-box .box {
  display: flex;
}
.swiper-box .swiper-item-box {
  height: 6.35vw !important;
}
.swiper-box .swiper-item {
  display: flex;
  align-items: center;
  margin: 0.2vw 0;
  height: 5.95vw;
  padding: 0 1.93vw 0 0.65vw;
  background-color: rgba(0, 51, 131, 0.2);
  border-radius: 3.6vw;
  box-sizing: border-box;
}
.swiper-box .swiper-item .avatar-box {
  flex-shrink: 0;
  width: 4.67vw;
  height: 4.67vw;
  border-radius: 50%;
  background-color: #fff;
  overflow: hidden;
  margin-right: 1.45vw;
}
.swiper-box .swiper-item .avatar-box .avatar {
  width: 4.67vw;
  height: 4.67vw;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.swiper-box .swiper-item .desc {
  max-width: 49.28vw;
  font-family: "PingFang SC";
  font-size: 3.38vw;
  font-style: normal;
  font-weight: 400;
  line-height: 5.95vw;
  color: #fff;
}
.swiper-box .lineclamp1 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

</style>
